module.exports = __webpack_public_path__ + "img/active.d919e820.svg";